export const DEFAULT_QUICK_LINKS = [
  { label: 'About', href: '/about', visible: true },
  { label: 'Leadership', href: '/leadership', visible: true },
  { label: 'Departments', href: '/departments', visible: true },
  { label: "Women's Department", href: '/womens', visible: true },
  { label: 'Events', href: '/events', visible: true },
  { label: 'Giving', href: '/giving', visible: true },
  { label: 'Prayer Request', href: '/prayer', visible: true },
];

export const defaultGivingLinks = (givelifyUrl) => [
  { label: 'Givelify', href: givelifyUrl || 'https://www.givelify.com/donate/wisconsin-first-ecclesiastical-jurisdiction', visible: true },
  { label: 'Direct-Give', href: '#give-by-mail', visible: true },
];
